module.exports = __webpack_public_path__ + "img/Presentation40.3db68999.png";